import { Circle, ShieldCheck } from "lucide-react";

import { Button } from "../ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "../ui/dialog";

// Perguntar antes de gravar.
//
// Gravar conversa alheia é decisão de pessoa, não de programa: a LGPD trata a
// gravação como dado pessoal, e quem responde por ela é quem atende — não o
// sistema que ligou o gravador sozinho. Por isso o padrão é NÃO gravar, e
// quando a empresa escolhe "perguntar", este aviso aparece antes de cada
// ligação.
//
// Os dois caminhos ligam a chamada. A diferença é só o gravador — e a
// gravação pode ser ligada depois, pelo botão da barra, quando o assunto
// mudar.

const AvisoDeGravacao = ({ aberto, paraQuem, aoEscolher, aoFechar }) => (
	<Dialog open={aberto} onOpenChange={(v) => !v && aoFechar()}>
		<DialogContent className="sm:max-w-md">
			<DialogHeader>
				<DialogTitle>Gravar esta chamada?</DialogTitle>
				<DialogDescription>
					{paraQuem ? (
						<>
							Você vai ligar para <strong>{paraQuem}</strong>.{" "}
						</>
					) : null}
					A gravação guarda a conversa inteira, dos dois lados.
				</DialogDescription>
			</DialogHeader>

			{/* O lembrete não é enfeite: quem grava tem de avisar, e o lugar de
			    lembrar disso é o segundo em que a pessoa decide. */}
			<div className="flex items-start gap-2 rounded-md bg-muted px-3 py-2 text-xs text-muted-foreground">
				<ShieldCheck className="mt-0.5 h-4 w-4 shrink-0" />
				<span>
					Avise a pessoa de que a chamada está sendo gravada, e para quê. É o
					que a LGPD exige — e dá para ligar ou desligar a gravação durante a
					conversa, pelo botão na barra da chamada.
				</span>
			</div>

			<DialogFooter className="gap-2 sm:justify-between">
				<Button variant="outline" onClick={() => aoEscolher(false)}>
					Ligar sem gravar
				</Button>
				<Button onClick={() => aoEscolher(true)}>
					<Circle className="h-4 w-4 fill-current" />
					Ligar gravando
				</Button>
			</DialogFooter>
		</DialogContent>
	</Dialog>
);

export default AvisoDeGravacao;
